/**
 * Utility functions for building dynamic className strings
 */

/**
 * Builds a className string from base class and conditional classes
 *
 * @param baseClassName - The base className to always include
 * @param conditionalClasses - Array of conditions and their corresponding class names
 * @returns Combined className string with all active classes
 *
 * @example
 * ```ts
 * const className = buildClassNames(
 *   'my-component',
 *   { condition: isActive, className: 'active' },
 *   { condition: isHovered, className: 'hovered' }
 * );
 * // Returns: "my-component active" (if isActive=true, isHovered=false)
 * ```
 */
export function buildClassNames(
  baseClassName: string,
  ...conditionalClasses: { condition: boolean; className: string }[]
): string {
  return [baseClassName, ...conditionalClasses.filter((c) => c.condition).map((c) => c.className)]
    .filter(Boolean)
    .join(' ');
}
